module.exports = __webpack_public_path__ + "img/colourshop.36ea3858.svg";